export default __webpack_public_path__ + "static/media/PROCESS_STEP3_XS.c59512d2.png";